

/*****************************************
 * helpers
 *****************************************/

// from idx i1 and up to i2 (not including)
export function hexToDecimal(val, i1, i2) {
  return parseInt(val.slice(i1, i2), 16);
}


// 2 chars
export function decimalToHex(val) {
  let hex = Math.floor(val + .5).toString(16);
  hex = hex.slice(-2).padStart(2, '0');
  return hex;
}


